export class YearDays {
  year: number = 0;
  mealTypeId: string = '';
  days: ServingDay[] = [];
}

export class ServingDay {
  day: number = 0;
  isNonCongregate: boolean = false;
}

export class SiteAppInfo {
  constructor(
    public siteId: number,
    public sponsorId: number,
    public programId: string,
    public programYearId: number,
    public operationStartDate: string,
    public operationEndDate: string,
    public years: YearDays[]) {
  }
}
